import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { media } from "utils/style";
import { convertStringToElements } from "@vds/html-parsers";

import { resetDownloadTypeToRegular } from "../actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import {ButtonGroup} from "@vds/buttons"
import Container from "common-components/Container";
import ReactButton from "common-components/Buttons";

class AffidavitPrimer extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Affidavit primer", this.props.pageContent.sc_pagetitle);
    }
  }

  resetDownloadTypeToRegular = () => {
    this.props.resetDownloadTypeToRegular();
    this.props.history.push("/privacy/secure/download-amount", {
      confirmAuth: true
    });
  };

  render() {
    const { pageContent } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }
     const regularDownload = this.props.noOfRegularDownloadRemaining === 0 ? true : false 
    return (
      <Container>
        <Header style={{ maxWidth: "346px" }}>{convertStringToElements(pageContent.section_title)}</Header>
        <Div>{convertStringToElements(pageContent.section_description)}</Div>
        <ButtonContainer>
          <ButtonGroup
            childWidth={'100%'}
            rowQuantity={{ desktop: 2,tablet: 2, mobile: 1 }}
            data={[
              {
              children: pageContent.buttons[0].text,
              size: 'large',
              use: pageContent.buttons[0].type !== 'white_background' ? 'primary' : 'secondary',
              width: 'auto',
              onClick:() =>
              this.props.history.push("/privacy/secure/affidavit-confirmation", {
              ...this.props.location.state
              })
            },
            ...( this.props.noOfRegularDownloadRemaining !== 0 ?
            [{
              children: pageContent.buttons[1].text,
              size: 'large',
              use: pageContent.buttons[1].type !== 'white_background' ? 'primary' : 'secondary',
              width: 'auto',
              onClick: () => this.resetDownloadTypeToRegular(),
            },
          ]
          : []
        ), 
        ]}
          alignment={''}
        />
      </ButtonContainer>
      </Container>
    );
  }
}

const mapStateToProps = ({ downloadAndDelete, pageContent }) => ({
  noOfRegularDownloadRemaining: downloadAndDelete.noOfRegularDownloadRemaining,
  pageContent: pageContent.affidavit_primer
});

export default connect(
  mapStateToProps,
  { resetDownloadTypeToRegular, setA11yContent }
)(AffidavitPrimer);

const Div = styled.div`
  max-width: 422px;
  margin-bottom: 56px;
  p {
    padding: 10px 0;
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  ${media.mobile`
   flex-direction: column;
  `}
`;

const Button = styled(ReactButton)`
  font-size: 14px;
`;
